import styled from '@emotion/styled';
import { shouldForwardProp } from '@/utils/style.utils';
import { CustomTheme } from '@tajawal/ct-web-design-system/dist/theme';

const TimeWrapper = styled('div', { shouldForwardProp })<{ $isDeparture: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $isDeparture }) => (!$isDeparture ? 'flex-end' : 'flex-start')};
  & > h2 {
    font-weight: bold;
  }
`;

const TimeFormat = styled('div', { shouldForwardProp })<{ $isAMFormat?: boolean }>`
  margin-left: 2px;
  position: relative;
  padding-top: ${({ $isAMFormat }) => ($isAMFormat ? '6px' : '28px')};
`;

const ArrivalFlag = styled.div`
  position: absolute;
  top: -8px;
  display: flex;
  justify-content: ${({ theme }: { theme?: CustomTheme }) => (!theme.isRtl ? 'flex-end' : 'flex-start')};
  width: 100%;
`;

const TimeTooltipContent = styled.div`
  display: flex;
  gap: 8px;
`;

export default {
  TimeWrapper,
  TimeFormat,
  ArrivalFlag,
  TimeTooltipContent,
};
